import { Grid16, List16 } from '@carbon/icons-react';
import React from 'react';
import { Switcher } from 'components/atoms/switcher';
import { CpSwitcher } from './cp-switcher';

export enum CpListOrGridSwitcherType {
  LIST = 'list',
  GRID = 'grid',
}

export const CPListOrGridSwitcher: React.FC<{
  type: CpListOrGridSwitcherType;
  onChange: (type: CpListOrGridSwitcherType) => void;
}> = ({ type, onChange }) => {
  return (
    <CpSwitcher
      hoverBgColor="white"
      activeColor="black"
      data-mode={type}
      value={type}
    >
      <Switcher.Button
        value={CpListOrGridSwitcherType.LIST}
        checked={type === CpListOrGridSwitcherType.LIST}
        onClick={() => onChange(CpListOrGridSwitcherType.LIST)}
      >
        <List16 />
      </Switcher.Button>
      <Switcher.Button
        value={CpListOrGridSwitcherType.GRID}
        checked={type === CpListOrGridSwitcherType.GRID}
        onClick={() => onChange(CpListOrGridSwitcherType.GRID)}
      >
        <Grid16 />
      </Switcher.Button>
    </CpSwitcher>
  );
};
